export default "__VITE_ASSET__ef004dbe__"